/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      d="M5 11.375v-3.75h1.5v3.75H5ZM5 3.875V2c0-1.1046.8954-2 2-2h1.875v1.5H7a.5.5 0 0 0-.5.5v1.875H5ZM12.625 0h3.75v1.5h-3.75V0ZM20.125 0H22c1.1046 0 2 .8954 2 2v1.875h-1.5V2a.5.5 0 0 0-.5-.5h-1.875V0ZM24 7.625v3.75h-1.5v-3.75H24ZM24 15.125V17c0 1.1046-.8954 2-2 2h-1.875v-1.5H22a.5.5 0 0 0 .5-.5v-1.875H24ZM16.375 19h-3.75v-1.5h3.75V19ZM5 17v-1.875h1.5V17a.5.5 0 0 0 .5.5h1.875V19H7c-1.1046 0-2-.8954-2-2Z"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M0 14.5c0-1.1046.8954-2 2-2h7.5c1.1046 0 2 .8954 2 2V22c0 1.1046-.8954 2-2 2H2c-1.1046 0-2-.8954-2-2v-7.5Zm2-.5h7.5a.5.5 0 0 1 .5.5V22a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-7.5A.5.5 0 0 1 2 14Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'MenuScaling'
);
